import { RouteType } from "types/RouteType";

const jobFieldReportingRoute: RouteType = {
  name: "Field Reporting",
  path: "/job/:jobNumber/field-reporting",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./JobFieldReportingDashboardHeader"),
      title: "Field Reporting Dashboard",
      enableRefreshButton: true,
      enableBackButton: true,
      enableToolbox: true,
    },
    body: {
      component: () => import("./JobFieldReportingDashboard.Body"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async ({ params, rootStore }) => {
    const jobNumber = params?.jobNumber;
    if (!jobNumber) {
      console.error("No job number provided");
      return false;
    }

    try {
      // Load the job details first
      await (rootStore.jobStore as any).find({
        query: {
          jobNumber,
          $limit: 1,
        },
      });

      // Load job-specific data
      await (rootStore.panelStore as any).find({
        query: {
          jobNumber,
          $limit: 1000,
        },
      });

      await (rootStore.hardwareOrdersStore as any).find({
        query: {
          jobNumber,
          $limit: 1000,
        },
      });

      await (rootStore.fieldActivityIssuesStore as any).find({
        query: {
          $limit: 1000,
        },
      });

      await (rootStore.fieldActivityStore as any).find({
        query: {
          jobNumber,
          $limit: 100,
          $sort: { activityDate: -1, activityTime: -1 },
        },
      });

      // Load users and teams for assignments
      if (rootStore.userStore) {
        await (rootStore.userStore as any).find({ query: { $limit: 100 } });
      }

      if (rootStore.departmentTeamsStore) {
        await (rootStore.departmentTeamsStore as any).find({
          query: { $limit: 100 },
        });
      }

      return true;
    } catch (error) {
      console.error("Error loading job field reporting data:", error);
      return false;
    }
  },
  onParamsChange: async ({ params, rootStore }) => {
    const jobNumber = params?.jobNumber;
    if (jobNumber && (rootStore as any).jobFieldReportingDashboardStore) {
      await (
        rootStore as any
      ).jobFieldReportingDashboardStore.loadJobDashboardData(jobNumber);
    }
  },
  dialogs: [
    {
      name: "FieldActivityIssuesList",
      component: () => import("../Dialogs/FieldActivityIssuesList"),
      title: "Field Activity Issues",
      cancelButton: false,
      height: 700,
    },
    {
      name: "FieldActivityIssueView",
      component: () => import("../Dialogs/FieldActivityIssueView"),
      title: "Issue Details",
      cancelButton: false,
      height: 700,
    },
    {
      name: "FieldActivityIssueForm",
      component: () => import("../Dialogs/FieldActivityIssueForm"),
      title: "Field Activity Issue",
      onSubmit: async ({ rootStore }) => {
        try {
          const store = (rootStore as any).fieldActivityIssuesViewStore;
          const success = await store.submitIssue();
          return success;
        } catch (error) {
          console.error("Error submitting field activity issue:", error);
          return false;
        }
      },
      onSubmitValidation: ({ rootStore }) => {
        const store = (rootStore as any).fieldActivityIssuesViewStore;
        return store.validateForm();
      },
      cancelButton: true,
      height: 650,
    },
  ],
};

export default jobFieldReportingRoute;
